import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import { Grid, Typography, Chip, IconButton, Collapse, FormControlLabel, Switch, Radio } from '@material-ui/core';
import { Build, KeyboardArrowUp, KeyboardArrowDown, Event } from '@material-ui/icons'
import Loader from 'components/Loader';
import Modal from 'components/Modal';
import Button from 'components/Button';
import ButtonConfirmation from 'components/ButtonConfirmation';
import ReactGoogleAutoComplete from 'react-google-autocomplete';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import { loadServicesScheduling, removeServicesScheduling, setUpdateServicesSchedulingConfirmation } from 'components/SchedulingServicesRegistration/store/thunk';
import { loadMapServices } from 'pages/Scheduling/store/thunk';

import { formatCurrency } from 'helpers/converters';
import { formatPhone, formatPermanence, capitalizeString } from 'helpers/formatters';
import { getEventColor } from 'pages/Scheduling/components/resources';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';

const Line = ({ children }) => {
  return(
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {children}
    </div>
  );
}

function ReactGoogleAutoCompleteInput({ setNewSchedulingAddress }) {
  return(
    <ReactGoogleAutoComplete
      style={{ margin: '10px 0 10px 0' }}
      id='delivery.address'
      name='delivery.address'
      placeholder='Digite um endereço'
      defaultValue=''
      apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}
      libraries={['places']}
      language='pt-BR'
      options={{
        types: [],
        componentRestrictions: {
          country: 'br'
        }
      }}
      onPlaceSelected={place => setNewSchedulingAddress(place?.formatted_address)}
      onFocus={event => {
        event.target.autocomplete = 'off';
      }}
    />
  );
}

export default function SchedulingMapEventView({ activeId = '', getDirections, userLocation }) {
  const dispatch = useDispatch();

  const history = useHistory();

  const { width } = useWindowDimensions();
  const isSm = width < 1150;

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { mapList, mapSelectedDate } = useSelector(state => state.scheduling);
  const { isLoading, submit } = useSelector(state => state.schedulingServices);
  const { startDate, endDate } = useSelector(state => state.dateFilter);

  const [isCollapsed, setIsCollapsed] = useState(!isSm);
  const [activeItem, setActiveItem] = useState('');
  const [newSchedulingAddress, setNewSchedulingAddress] = useState('');
  const [actionEventType, setActionEventType] = useState('all');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isConfirmedModalConfirmationOpen, setIsConfirmedModalConfirmationOpen] = useState(false);

  const mapDates = !!mapSelectedDate
    ? [mapSelectedDate]
    : [...new Set(mapList
        ?.map(item => moment(item.startDateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))
        ?.sort((firstDate, secondDate) => moment.utc(firstDate).diff(moment.utc(secondDate)))
      )];

  const formattedMapList = mapDates?.map(item => {
    return {
      date: item,
      mapList: mapList?.filter(map => moment(map.startDateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') == item)
    }
  });

  useEffect(() => {
    setActiveItem(activeId);
  }, [activeId]);

  useEffect(() => {
    if(activeItem) {
      dispatch(loadServicesScheduling(userId, establishmentId, activeItem));
    }
  }, [activeItem]);

  useEffect(() => {
    if(+submit?.situationId == 2) {
      return setIsConfirmed(true);
    }

    setIsConfirmed(false);
  }, [submit?.situationId]);

  return(
    <div style={{ position: 'absolute', height: isSm ? 'fit-content' : '69vh', width: isSm ? '98%' : 350, overflowY: isCollapsed ? 'scroll' : 'hidden', backgroundColor: '#FFFFFF', border: '1px solid #E4E7EA', borderRadius: 5, zIndex: 10, padding: 10, marginTop: 5, left: isSm ? '1%' : 5, right: '1%', zIndex: 900 }}>
      {isConfirmedModalConfirmationOpen && (
        <Modal
          id='isConfirmedModalConfirmation'
          title='Confirmar agendamento'
          maxWidth='sm'
          open={isConfirmedModalConfirmationOpen}
          onClose={() => {
            setIsConfirmedModalConfirmationOpen(false);
            setIsConfirmed(!isConfirmed);
          }}
        >
          {!isConfirmed ? (
            <Typography>Tem certeza que deseja desconfirmar o agendamento?</Typography>
          ) : (
            <Typography>Tem certeza que deseja confirmar o agendamento?</Typography>
          )}
          <Grid container xs={12} justify='flex-end' style={{ gap: 10 }}>
            <Button
              color='error'
              onClick={() => {
                setIsConfirmedModalConfirmationOpen(false);
                setIsConfirmed(!isConfirmed);
              }}
            >
              Não
            </Button>
            <Button
              color='success'
              onClick={() => {
                dispatch(setUpdateServicesSchedulingConfirmation(userId, establishmentId, submit?.id)).then(() => {
                  dispatch(loadMapServices(userId, establishmentId, startDate, endDate, ''));
                  setIsConfirmedModalConfirmationOpen(false);
                });
              }}
            >
              Sim
            </Button>
          </Grid>
        </Modal>
      )}
      {isSm && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Event fontSize='large' style={{ color: '#13BC4B' }} />
            <Typography variant='body1'>
              <b>Meus agendamentos</b>
            </Typography>
          </div>
          <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
            {isCollapsed ? (
              <KeyboardArrowUp fontSize='large' />
            ) : (
              <KeyboardArrowDown fontSize='large' />
            )}
          </IconButton>
        </div>
      )}
      <Collapse in={isCollapsed}>
        <Grid container>
          {(+mapList?.length == 0) && (
            <>
              <Typography color='primary' align='center'>
                <b>Vamos criar um agendamento?</b>
              </Typography>
              <Typography color='textSecondary'>
                Para criar seu primeiro agendamento delivery digite o endereço do cliente.
              </Typography>
              <ReactGoogleAutoCompleteInput setNewSchedulingAddress={setNewSchedulingAddress} />
              <Button
                fullWidth
                type='button'
                color='success'
                onClick={() => {
                  history.push({
                    pathname: '/novo-agendamento-servico',
                    state: {
                      data: {
                        newSchedulingAddress
                      }
                    }
                  })
                }}
              >
                Avançar
              </Button>
            </>
          )}
          {formattedMapList?.map(item => {
            return(
              <>
                <Grid item xs={12}>
                  <Typography style={{ borderBottom: '1px solid #D7D7D7', marginBottom: 10 }}>
                    <b>{capitalizeString(moment(item?.date, 'YYYY-MM-DD').format('ddd DD/MM/YYYY'))}</b>
                  </Typography>
                </Grid>
                {item?.mapList?.map(item => {
                  return(
                    <>
                      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, backgroundColor: '#FFFFFF', border: '1px solid #D7D7D7', borderLeft: `15px solid ${getEventColor(item.situationId)}`, borderRadius: 5, marginBottom: 10 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {!isSm && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#757575', height: 30, width: 30, borderRadius: '50%', marginLeft: 10, marginRight: 10, aspectRatio: 1 }}>
                              <Build fontSize='small' style={{ color: '#FFFFFF' }} />
                            </div>
                          )}
                          <div style={{ marginLeft: isSm ? 10 : 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                              <Typography>
                                <b>{item?.services[0]?.serviceName || '-'}</b>
                              </Typography>
                              {(item?.services?.length > 1) && (
                                <Chip
                                  style={{ backgroundColor: 'rgba(2, 42, 92, 0.18)', height: 20 }}
                                  label={
                                    <Typography color='primary'>+ {item?.services?.length}</Typography>
                                  }
                                />
                              )}
                            </div>
                            <div>
                              <Typography>{moment(item.startDateTime, 'YYYY-MM-DD HH:mm:ss').format('hh:mma')} - {moment(item.endDateTime, 'YYYY-MM-DD HH:mm:ss').format('hh:mma')}</Typography>
                            </div>
                            {isSm && (
                              <div>
                                <Typography variant='subtitle2' color='textSecondary'>
                                  {submit?.completeAddress || '-'}
                                </Typography>
                              </div>
                            )}
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {isSm && (
                            <button
                              style={{ backgroundColor: '#1E5168', color: '#FFFFFF', height: 32, width: 32, border: 0, borderRadius: '50%', cursor: 'pointer', aspectRatio: '1 !important' }}
                              onClick={() => getDirections(userLocation, { lat: item.latitude, lng: item.longitude })}
                            >
                              <b>IR</b>
                            </button>
                          )}
                          <IconButton
                            onClick={() => {
                              if(activeItem == item.id) {
                                return setActiveItem('');
                              }

                              setActiveItem(item.id);
                            }}
                          >
                            {(activeItem == item.id) ? (
                              <KeyboardArrowUp fontSize='large' />
                            ) : (
                              <KeyboardArrowDown fontSize='large' />
                            )}
                          </IconButton>
                        </div>
                      </Grid>
                      <Collapse in={(activeItem == item.id)} style={{ width: '100%' }}>
                        <Loader isLoading={isLoading}>
                          <Grid container style={{ marginBottom: 10 }}>
                            <Grid xs={12}>
                              <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginTop: 10, marginBottom: 10 }}>
                                <b>Data e Hora</b>
                              </Typography>
                              <Line>
                                <Typography variant='subtitle2'>Início</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>
                                  {moment(item.startDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY - HH:mm')}
                                </Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Fim</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>
                                  {moment(item.endDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY - HH:mm')}
                                </Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Período</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>
                                  {formatPermanence([item?.endDateTime, item?.startDateTime])}
                                </Typography>
                              </Line>
                            </Grid>
                            <Grid xs={12}>
                              <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginTop: 10, marginBottom: 10 }}>
                                <b>Informações do cliente</b>
                              </Typography>
                              <Line>
                                <Typography variant='subtitle2'>Cliente</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>{submit?.client?.name || '-'}</Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Telefone</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>{submit?.client?.phone ? formatPhone(submit?.client?.phone) : '-'}</Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>E-mail</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>{submit?.client?.email || '-'}</Typography>
                              </Line>
                            </Grid>
                            <Grid xs={12}>
                              <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginTop: 10, marginBottom: 10 }}>
                                <b>Informações do veículo</b>
                              </Typography>
                              <Line>
                                <Typography variant='subtitle2'>Placa</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>{submit?.vehicle?.plate || '-'}</Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Modelo</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>{submit?.vehicle?.vehicleModel || '-'}</Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Cor</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>{submit?.vehicle?.vehicleColor || '-'}</Typography>
                              </Line>
                            </Grid>
                            <Grid xs={12}>
                              <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginBottom: 10 }}>
                                <b>Serviços</b>
                              </Typography>
                              {item?.services?.map(service => {
                                return(
                                  <Line>
                                    <Typography variant='subtitle2'>{service?.quantity}x {service?.serviceName}</Typography>
                                    <Typography variant='subtitle2' color='textSecondary'>{formatCurrency(service?.amount)}</Typography>
                                  </Line>
                                );
                              })}
                              <Line>
                                <Typography variant='subtitle2'>TOTAL</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>
                                  {formatCurrency(item?.services.reduce((total, service) => total + +service?.amount, 0))}
                                </Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Tempo de execução</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>
                                  {moment.utc().startOf('day').add({ minutes: item?.services?.reduce((total, service) => total + +service.executionTime, 0) }).format('HH[h] mm[min]')}
                                </Typography>
                              </Line>
                            </Grid>
                            <Grid xs={12}>
                              <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginBottom: 10 }}>
                                <b>Pagamento</b>
                              </Typography>
                              <Line>
                                <Typography variant='subtitle2'>Situação</Typography>
                                <Chip
                                  style={{ backgroundColor: 'rgba(19, 188, 75, 0.2)', color: '#13BC4B', height: 20 }}
                                  label={
                                    <Typography>Confirmado</Typography>
                                  }
                                />
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Pagamento</Typography>
                                <Chip
                                  style={{ backgroundColor: 'rgba(245, 185, 65, 0.2)', color: '#F5B941', height: 20 }}
                                  label={
                                    <Typography>Aguardando pagamento</Typography>
                                  }
                                />
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Forma de pagamento</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>{item?.paymentMethod || '-'}</Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Total do serviço</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>
                                  {formatCurrency(item?.services.reduce((total, service) => total + +service?.amount, 0))}
                                </Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>Desconto</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>{formatCurrency(item?.discount || 0)}</Typography>
                              </Line>
                              <Line>
                                <Typography variant='subtitle2'>TOTAL</Typography>
                                <Typography variant='subtitle2' color='textSecondary'>
                                  {formatCurrency(item?.services.reduce((total, service) => total + +service?.amount, 0) - (item?.discount || 0))}
                                </Typography>
                              </Line>
                            </Grid>
                            <Grid xs={12}>
                              <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginBottom: 10 }}>
                                <b>Endereço</b>
                              </Typography>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                  <Typography variant='subtitle2' color='textSecondary'>
                                    {submit?.completeAddress || '-'}
                                  </Typography>
                                </div>
                                <button
                                  style={{ backgroundColor: '#1E5168', color: '#FFFFFF', height: 32, width: 32, border: 0, borderRadius: '50%', marginLeft: 20, cursor: 'pointer', aspectRatio: '1 !important' }}
                                  onClick={() => getDirections(userLocation, { lat: item.latitude, lng: item.longitude })}
                                >
                                  <b>IR</b>
                                </button>
                              </div>
                            </Grid>
                            <Grid item xs={12}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    name="isConfirmed"
                                    color="primary"
                                    value={isConfirmed}
                                    checked={isConfirmed}
                                    onChange={event => {
                                      setIsConfirmed(event.target.checked);
                                      setIsConfirmedModalConfirmationOpen(true);
                                    }}
                                  />
                                }
                                label={
                                  <Typography color='primary'>Agendamento confirmado</Typography>
                                }
                              />
                            </Grid>
                            <Grid xs={12} style={{ display: 'flex', flexDirection: isSm ? 'column' : 'row', justifyContent: 'flex-start', gap: 10, marginTop: 10 }}>
                              <Button
                                fullWidth={isSm}
                                type='button'
                                color='tertiary'
                                variant='outlined'
                                onClick={() => {
                                  history.push({
                                    pathname: '/editar-agendamento-servico',
                                    state: {
                                      data: {
                                        id: submit?.id
                                      }
                                    }
                                  });
                                }}
                                startIcon={
                                  <FontAwesomeIcon
                                    size='xs'
                                    icon={faPen}
                                  />
                                }
                              >
                                Editar
                              </Button>
                              {(submit?.recurrence?.frequencyId > 0) && (
                                <ButtonConfirmation
                                  fullWidth={isSm}
                                  title='Remover Agendamento'
                                  color='error'
                                  variant='outlined'
                                  isCancelButton={false}
                                  modalTitle='Remover agendamento'
                                  modalText={
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                      <FormControlLabel
                                        style={{ backgroundColor: (actionEventType == 'single') ? '#F0F2F6' : '#FCFCFC', border: '1px solid #D7D7D7', borderRadius: 5, margin: 0 }}
                                        control={
                                          <Radio
                                            style={{ color: '#1E5168' }}
                                            checked={actionEventType == 'single'}
                                            onChange={() => setActionEventType('single')}
                                          />
                                        }
                                        label={
                                          <Typography color='textSecondary' variant='body2'>
                                            Este evento
                                          </Typography>
                                        }
                                      />
                                      <FormControlLabel
                                        style={{ backgroundColor: (actionEventType == 'all') ? '#F0F2F6' : '#FCFCFC', border: '1px solid #D7D7D7', borderRadius: 5, margin: 0 }}
                                        control={
                                          <Radio
                                            style={{ color: '#1E5168' }}
                                            checked={actionEventType == 'all'}
                                            onChange={() => setActionEventType('all')}
                                          />
                                        }
                                        label={
                                          <Typography color='textSecondary' variant='body2'>
                                            Este e os seguintes eventos
                                          </Typography>
                                        }
                                      />
                                    </div>
                                  }
                                  modalButtons={[
                                    {
                                      fullWidth: true,
                                      color: 'error',
                                      title: 'Remover agendamento',
                                      onClick: () => {
                                        const params = {
                                          recurrence: {
                                            applyToAll: actionEventType == 'all'
                                          }
                                        }

                                        dispatch(removeServicesScheduling(userId, establishmentId, submit?.id, params)).then(() => {
                                          dispatch(loadMapServices(userId, establishmentId, startDate, endDate, ''));
                                        });
                                      }
                                    }
                                  ]}
                                />
                              )}
                              {!submit?.recurrence?.frequencyId && (
                                <ButtonConfirmation
                                  fullWidth={isSm}
                                  title='Remover Agendamento'
                                  color='error'
                                  variant='outlined'
                                  cancelTitle='Fechar'
                                  cancelColor='tertiary'
                                  cancelVariant='outlined'
                                  cancelFullWidth={isSm}
                                  modalTitle='Confimar remoção'
                                  modalText={
                                    <>
                                      <Typography color='textSecondary' variant='subtitle2'>
                                        {isSm ? 'Deseja confimar a remoção do agendamento?' : 'Deseja confimar a remoção do agendamento:'}
                                      </Typography>
                                      {!isSm && (
                                        <Typography color='primary' variant='subtitle2'>
                                          {(submit?.services?.length > 0) && submit?.services[0]?.serviceName} ({moment(submit?.timeStart, 'HH:mm').format('HH:mma')} - {moment(submit?.timeEnd, 'HH:mm').format('HH:mma')})
                                        </Typography>
                                      )}
                                      {isSm && (
                                        <>
                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #E4E7EA', marginTop: 10, marginBottom: 10 }}>
                                            <Typography variant='subtitle2'>Cliente</Typography>
                                            <Typography variant='subtitle2' color='textSecondary'>{submit?.clientName || '-'}</Typography>
                                          </div>
                                          <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginBottom: 10 }}>
                                            <b>Serviços</b>
                                          </Typography>
                                          {submit?.services?.map(service => {
                                            return (
                                              <Line>
                                                <Typography variant='subtitle2'>{service.quantity}x {service.serviceName}</Typography>
                                                <Typography variant='subtitle2' color='textSecondary'>{formatCurrency(service.amount)}</Typography>
                                              </Line>
                                            );
                                          })}
                                          <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginTop: 10, marginBottom: 10 }}>
                                            <b>Data e Hora</b>
                                          </Typography>
                                          <Line>
                                            <Typography variant='subtitle2'>Início</Typography>
                                            <Typography variant='subtitle2' color='textSecondary'>
                                              {moment(submit?.dateStart, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {submit?.timeStart}
                                            </Typography>
                                          </Line>
                                          <Line>
                                            <Typography variant='subtitle2'>Fim</Typography>
                                            <Typography variant='subtitle2' color='textSecondary'>
                                              {moment(submit?.dateEnd, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {submit?.timeEnd}
                                            </Typography>
                                          </Line>
                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #E4E7EA', marginTop: 20, marginBottom: 10 }}>
                                            <Typography variant='subtitle2'>TOTAL</Typography>
                                            <Typography variant='subtitle2' color='textSecondary'>
                                              {formatCurrency(submit?.services?.reduce((total, service) => total + +service.amount, 0))}
                                            </Typography>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  }
                                  modalButtons={[
                                    {
                                      fullWidth: isSm,
                                      color: 'error',
                                      title: 'Remover agendamento',
                                      onClick: () => {
                                        dispatch(removeServicesScheduling(userId, establishmentId, submit?.id)).then(() => {
                                          dispatch(loadMapServices(userId, establishmentId, startDate, endDate, ''));
                                        });
                                      }
                                    }
                                  ]}
                                />
                              )}
                            </Grid>
                          </Grid>
                        </Loader>
                      </Collapse>
                    </>
                  );
                })}
              </>
            );
          })}
        </Grid>
      </Collapse>
    </div>
  );
}